// @layout/AppLayout.jsx
import React, {
  useEffect,
  useState,
  createContext,
} from "react";
import TopNavBar from "@components/TopNavBar";
import LeftSidebar from "@components/LeftSidebar";
import { Outlet } from "react-router-dom";
import { getAllPermissions } from "@utils/usePermission";
import GlobalModals from '@components/GlobalModals'; // ✅ Centralized modal loader
export const PermissionContext = createContext({
  permissions: {},
  setPermissions: () => {},
});

const AppLayout = () => {
  const [permissionsCache, setPermissionsCache] = useState({});

  // ✅ Load permissions once when AppLayout mounts
  useEffect(() => {
    const perms = getAllPermissions();
    // console.log("mount first time",perms);
    // console.log("🔐 AppLayout loaded permissions:", perms);
    setPermissionsCache(perms);
    window.__permissionsCache = perms; // for canUser()
  }, []);

  // ✅ Optional: listen for refresh events (company change / manual refresh)
  useEffect(() => {
    const handleRefreshPermissions = () => {
      const newPerms = getAllPermissions();
      //console.log("🔄 Permissions refreshed:", newPerms);
      setPermissionsCache(newPerms);
      window.__permissionsCache = newPerms;
    };

    window.addEventListener("refreshPermissions", handleRefreshPermissions);
    window.addEventListener("companyChanged", handleRefreshPermissions);

    return () => {
      window.removeEventListener("refreshPermissions", handleRefreshPermissions);
      window.removeEventListener("companyChanged", handleRefreshPermissions);
    };
  }, []);

  return (
    <PermissionContext.Provider
      value={{
        permissions: permissionsCache,
        setPermissions: setPermissionsCache,
      }}
    >
      <div className="app-container">
        <TopNavBar />
        <LeftSidebar />
        <GlobalModals/>
        <div className="main-layout bg-[#fff] h-[calc(100vh-40px)] overflow-y-auto pl-0 lg:pl-[80px] mt-[40px]">
          <main className="content max-h-full bg-gray-50">
            <div className="border-l-1 border-t-1 rounded-tl-lg bg-gray-50 h-full">
              <div className="p-3 h-full">
                <Outlet />
              </div>
            </div>
          </main>
        </div>
      </div>
    </PermissionContext.Provider>
  );
};

export default AppLayout;
